import DifficultyEasy from '@alltrails/denali/icons/DifficultyEasy';
import DifficultyHard from '@alltrails/denali/icons/DifficultyHard';
import DifficultyModerate from '@alltrails/denali/icons/DifficultyModerate';
import DifficultyStrenuous from '@alltrails/denali/icons/DifficultyStrenuous';

type DifficultyIconProps = {
  className?: string;
  difficulty?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

/**
 * Difficulty icon component that displays the icon based on difficulty rating
 *
 * @param {string} className - Classname for the icon
 * @param {number} difficulty - The difficulty rating (1-8)
 * @param {string} size - Icon size (default: 'xs')
 * @returns JSX element with the difficulty icon or null
 */
const DifficultyIcon = ({ className, difficulty, size = 'xs' }: DifficultyIconProps) => {
  if (!difficulty) {
    return null;
  }

  if ([1, 2].includes(difficulty)) {
    return <DifficultyEasy className={className} size={size} color="--color-difficulty-easy" />;
  }

  if ([3, 4].includes(difficulty)) {
    return <DifficultyModerate className={className} size={size} color="--color-difficulty-moderate" />;
  }

  if ([5, 6].includes(difficulty)) {
    return <DifficultyHard className={className} size={size} color="--color-difficulty-hard" />;
  }

  if ([7, 8].includes(difficulty)) {
    return <DifficultyStrenuous className={className} size={size} color="--color-difficulty-strenuous" />;
  }

  return null;
};

export default DifficultyIcon;
